module.exports = __webpack_public_path__ + "img/bx-2.60960c79.jpg";